Vendd.Scripts.load(function () {
 
    var $wrapper = $('.x-main-category-list');
    var resize = false;
    var ww = $(window).width();
    var masonryState = false;
    
    if ($wrapper.length <= 0)
        return;
    
    var $masonryTarget = $('.js-init-masonry', $wrapper);

    checkToInit($masonryTarget)

    $( window ).on('resize', function() {
        ww = $(window).width();
        resize = true;
    })

    setInterval(function(){
        if(resize){
            checkToInit($masonryTarget)
            resize = false;
        }
    }, 500)

    
    function checkToInit($container){
        if(ww > 768 && !masonryState) {
            initMasonryContainer($container)
        } else if(ww <=768 && masonryState) {
            $container.masonry('destroy');
            $container.removeData('masonry');
            masonryState = false;
        }
    }


    function initMasonryContainer($masonryTarget) {
        $masonryTarget.masonry({
            itemSelector: '.category-item',
            columnWidth: '.masonry-grid-sizer',
            gutter: '.masonry-gutter-size'
        });
        $('>.category-item', $masonryTarget).addClass('shown');
        masonryState = true;
    }
});